"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mock = exports.fetch = exports.timeout = exports.circuitBreaker = exports.log = exports.retry = exports.forwardTracingHeaders = exports.DEFAULT_MIDDLEWARES = exports.fetchFactory = void 0;
const circuitBreaker_1 = require("./circuitBreaker");
Object.defineProperty(exports, "circuitBreaker", { enumerable: true, get: function () { return circuitBreaker_1.circuitBreaker; } });
const fetchMiddleware_1 = require("./fetchMiddleware");
Object.defineProperty(exports, "fetch", { enumerable: true, get: function () { return fetchMiddleware_1.fetchMiddleware; } });
const forwardTracingHeaders_1 = require("./forwardTracingHeaders");
Object.defineProperty(exports, "forwardTracingHeaders", { enumerable: true, get: function () { return forwardTracingHeaders_1.forwardTracingHeaders; } });
const is_plain_object_1 = require("is-plain-object");
const log_1 = require("./log");
Object.defineProperty(exports, "log", { enumerable: true, get: function () { return log_1.log; } });
const mock_1 = require("./mock");
Object.defineProperty(exports, "mock", { enumerable: true, get: function () { return mock_1.mock; } });
const retry_1 = require("./retry");
Object.defineProperty(exports, "retry", { enumerable: true, get: function () { return retry_1.retry; } });
const timeout_1 = require("./timeout");
Object.defineProperty(exports, "timeout", { enumerable: true, get: function () { return timeout_1.timeout; } });
const deepmerge_1 = __importDefault(require("deepmerge"));
// modified version of koa-compose that allows retries
function compose(middleware) {
    return (ctx, next) => {
        // last called middleware #
        let index = -1;
        const dispatch = (i) => __awaiter(this, void 0, void 0, function* () {
            index = i;
            const fn = i === middleware.length ? next : middleware[i];
            if (!fn)
                return undefined;
            return fn(ctx, () => dispatch(i + 1));
        });
        return dispatch(0);
    };
}
/**
 * Make a fetch function that will process all middlewares
 */
function fetchFactory(middlewares, defaultOptions = {}) {
    const flow = compose(middlewares);
    // it complains that the return function is not strict enough to fit the return type
    // but that is exactly what we want to do here, make it type strict here
    // @ts-ignore
    return (input, options = {}) => __awaiter(this, void 0, void 0, function* () {
        const ctx = {
            input,
            options: (0, deepmerge_1.default)(defaultOptions, options, {
                isMergeableObject: is_plain_object_1.isPlainObject,
            }),
        };
        yield flow(ctx);
        if (ctx.response)
            return ctx.response;
        throw new Error("No fetch middleware set response or throw error, check if you have correctly initialized fetch");
    });
}
exports.fetchFactory = fetchFactory;
// default set of middlewares is exported as array so it allows consumers to extend it
exports.DEFAULT_MIDDLEWARES = [
    forwardTracingHeaders_1.forwardTracingHeaders,
    retry_1.retry,
    log_1.log,
    circuitBreaker_1.circuitBreaker,
    timeout_1.timeout,
];
exports.default = fetchFactory([...exports.DEFAULT_MIDDLEWARES, fetchMiddleware_1.fetchMiddleware]);
//# sourceMappingURL=index.js.map